import Cookies from 'universal-cookie';
import { format } from 'date-fns';
import { handleLogoutUser } from '../views/utils/Utils';
import { apiEndpoints } from '../constants/apiEndpoints';
const axios = require('axios');

const authExpireAt = (expirySec) => {
  const date = new Date();
  return format(new Date(date.setSeconds(date.getSeconds() + parseInt(expirySec, 10) - 20)), 'yyyy/MM/dd hh:mm a');
};

const COOKIE_ATTR = {
  path: '/',
  maxAge: 31536000,
  // httpOnly: true,
  sameSite: true,
  secure: true,
};

// if access token expired then use the refresh token to get new access token
// if refresh token expired then logout user
// if there is a error in api while getting new access token logout user

const GetToken = async () => {
  const cookies = new Cookies();
  const refreshToken = cookies.get('refresh_token');
  const authExpires = cookies.get('auth_expires');

  if (new Date(authExpires).getTime() < new Date().getTime()) {
    const config = {
      method: 'get',
      url: apiEndpoints.AUTH_GET_TOKEN,
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    };

    try {
      const response = await axios(config);
      const expiresAt = authExpireAt(response.headers.expires);
      cookies.set('access_token', response.data.result.accessToken, {
        ...COOKIE_ATTR,
      });
      cookies.set('refresh_token', response.data.result.refreshToken, {
        ...COOKIE_ATTR,
      });
      cookies.set('auth_expires', expiresAt, {
        ...COOKIE_ATTR,
      });
      cookies.set('media_token', response.data.result.mediaToken, {
        ...COOKIE_ATTR,
      });
    } catch (err) {
      if (err?.response?.status === 400) {
        handleLogoutUser();
      }
    }
  }
};
export default GetToken;
